import { render, staticRenderFns } from "./DownloadLinkMobileApp.vue?vue&type=template&id=2278de54&scoped=true"
import script from "./DownloadLinkMobileApp.vue?vue&type=script&lang=js"
export * from "./DownloadLinkMobileApp.vue?vue&type=script&lang=js"
import style0 from "./DownloadLinkMobileApp.vue?vue&type=style&index=0&id=2278de54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278de54",
  null
  
)

export default component.exports